module.exports = __webpack_public_path__ + "img/OVCA_Treg.a0457e82.png";